module.exports = __webpack_public_path__ + "img/how-to.2ba97de3.svg";